import { render } from "./LdapConfiguration.vue?vue&type=template&id=0fd04af0&scoped=true"
import script from "./LdapConfiguration.vue?vue&type=script&lang=js"
export * from "./LdapConfiguration.vue?vue&type=script&lang=js"

import "./ldap-configuration.scss?vue&type=style&index=0&id=0fd04af0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd04af0"]])

export default __exports__